<template>
	<div class="container">
		<div class="container_bg"></div>
	</div>
</template>

<script>
	import {Toast, MessageBox } from "mint-ui";
	export default {
		data() {
			return {
				boyBook:0,
				girlBook:0,
				accountDevNum:''
			}
		},
		mounted() { //监听页面加载
	         this.boyBook=this.$route.query.boyBook;
			 this.girlBook=this.$route.query.girlBook;
			 this.accountDevNum=this.$route.query.accountDevNum;
			 console.log('111')
			this.wechatLogin()		
		},
		methods: {
			wechatLogin() {
				this.code = this.$base.GetUrlParam('code');
				if (!this.code) {
					console.log(window.location.href)
					// snsapi_base//静默   snsapi_userinfo手动
					let uri = encodeURIComponent(window.location.href);
					window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.$store.state.user
						.appid +"&redirect_uri=" + uri +
						"&response_type=code&scope=snsapi_base&state=state&wechat_redirect&connect_redirect=1#wechat_redirect"
				} else {
					this.userRegister(); //静默注册
				}
			},
			userRegister() {
				var params = {
					code: this.code,
					accountDevNum:this.accountDevNum//绑定快应用用户
				}
				this.$api.userRegister(params).then(res => {
					if (res.status == 1) {
						 this.$base.setStorage('openid', res.data.openid)
						this.getUserbookid(res.data.isNewUser,res.data.frequency)
						this.$commonApi.getUserInfo(res.data.openid)
					}
				})
			},
			getUserbookid(isNewUser,frequency){
				if(isNewUser==1){//新用户跳转到男女频类选择
				   this.$base.setStorage("taskIndex",'isNewUser')
					this.$router.replace({path:'/pages/bookFrency/index',params:{pageType:'index',boyBook:this.boyBook,girlBook:this.girlBook}})
				}else{
					var bookId=frequency==1?this.girlBook:this.boyBook;
						this.$router.replace({path:'/pages/bookRead/index',params:{pageType:'index',bookid:bookId}})
				}
			}
		}
	}
</script>

<style scoped>
	.container {
		padding: 0px 16px;
	}
	.container_bg{
		width:30px;
		height: 46px;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
		background-color: #FFFFFF;
	}

</style>



// WEBPACK FOOTER //
// src/view/index/index.vue